import * as React from 'react';
import { Modal, Row, Col, Card, Typography } from 'antd';
import { LineChartOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { DiscountBandType } from 'app/shared/model';

const { Title, Paragraph } = Typography;

interface BandTypeSelectionStepProps {
  bandTypes: DiscountBandType[];
  isVisible: boolean;
  onSelect: (type: DiscountBandType) => void;
  onCloseWizard: () => void;
}

export default function BandTypeSelectionStep(
  props: BandTypeSelectionStepProps
) {
  const { bandTypes, isVisible, onSelect, onCloseWizard } = props;

  // up to three cards per row
  const perRow = Math.min(bandTypes.length, 3);
  const span = Math.floor(24 / perRow);

  return (
    <Modal
      title="How should the discount be applied?"
      open={isVisible}
      onCancel={onCloseWizard}
      footer={null}
      mask={{ closable: false }}
      destroyOnHidden
      width="70%"
    >
      <Row gutter={[24, 24]} justify="center">
        {bandTypes.map(type => (
          <Col key={type.Mode} xs={24} sm={12} md={span}>
            <Card
              hoverable
              style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
              styles={{ body: { flex: 1 } }} 
              actions={[
                <a key="select" onClick={() => onSelect(type)}>
                  Select
                </a>
              ]}
            >
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12, gap: 8 }}>
                {getIcon(type)}
                <Title level={5} style={{ margin: 0 }}>
                  {type.Mode}
                </Title>
              </div>
              <Paragraph style={{ flex: 1, overflowY: 'auto' }}>
                {type.Description}
              </Paragraph>
              <Paragraph>
                <strong>Example</strong>
                <br />
                {type.Example}
              </Paragraph>
              <Paragraph>{type.ExampleExplanation}</Paragraph>
            </Card>
          </Col>
        ))}
      </Row>
    </Modal>
  );
}

function getIcon(type: DiscountBandType) {
  const style = { fontSize: '1.4em' };
  return type === DiscountBandType.Compound ? (
    <LineChartOutlined style={style} />
  ) : (
    <UnorderedListOutlined style={style} />
  );
}
